import {
  CreateTask,
  createTask,
  getTemplateDetail,
  getResultTemplateDetail,
  getTplList,
  GetTplList,
  targetList,
  TaskTemplate,
  taskTemplate,
  TemplateDetail,
  ResultTemplateDetail,
  getTagTreeOptions,
} from '@/api/data-protection/create'
import { Message } from '@/components/message'
import { useRequest } from 'ahooks'
import { message } from 'antd'
import { t } from '@/i18n'
// 模板列表
interface GetTplProps {
  GetTplParams: GetTplList
}
export const useGetTplList = (props: GetTplProps) => {
  const { GetTplParams } = props
  const { runAsync: run, data } = useRequest(() => getTplList(GetTplParams), {
    refreshDeps: [GetTplParams],
    onError: (err: any) => {
      Message.error(err?.msg || t('模板列表获取失败'))
    },
  })
  return [run, data?.data] as const
}
// 创建任务-安全域列表
export const useTargetList = () => {
  const { runAsync: run, data } = useRequest(() => targetList(), {
    onError: (err: any) => {
      Message.error(err?.msg || t('安全域列表获取失败'))
    },
  })
  return [run, data?.data?.items] as const
}
// 创建任务模板解析
export const useTaskTemplate = () => {
  const { runAsync: run, data } = useRequest((datas: TaskTemplate) => taskTemplate(datas), {
    manual: true,
    onError: (err: any) => {},
  })
  return [run, data?.data] as const
}
// 创建任务
export const useCreateTask = () => {
  const { runAsync: run, loading } = useRequest((datas: CreateTask) => createTask(datas), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('创建任务失败'))
    },
  })
  return [run, loading] as const
}

// 模板详情
export const useTemplateDetail = () => {
  const { runAsync: run, loading } = useRequest(
    (datas: TemplateDetail) => getTemplateDetail(datas),
    {
      manual: true,
      onError: (err: any) => {
        Message.error(err?.msg || t('获取模板详情失败'))
      },
    },
  )
  return [run, loading] as const
}

// 模板详情
export const useResultTemplateDetail = () => {
  const { runAsync: run, loading } = useRequest(
    (datas: ResultTemplateDetail) => getResultTemplateDetail(datas),
    {
      manual: true,
      onError: (err: any) => {
        Message.error(err?.msg || t('获取模板详情失败'))
      },
    },
  )
  return [run, loading] as const
}

// 模板标签组列表
export const useGetTagTreeOptions = () => {
  const { runAsync: run, data } = useRequest(params => getTagTreeOptions(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('获取标签列表失败'))
    },
  })
  return [run, data?.data?.categoryList || []] as const
}
